import { render, staticRenderFns } from "./FieldColor.vue?vue&type=template&id=41c3f53e&scoped=true&"
import script from "./FieldColor.vue?vue&type=script&lang=js&"
export * from "./FieldColor.vue?vue&type=script&lang=js&"
import style0 from "./FieldColor.vue?vue&type=style&index=0&id=41c3f53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c3f53e",
  null
  
)

export default component.exports